module.exports = __webpack_public_path__ + "img/gallery-17.8fd46d41.jpg";